import styles from './styles/HouseManagerProfile.module.css'
import useContracts from './hooks/useContracts'
import useProfileData from "./hooks/useProfileData";
import { useState } from "react";
import { useLocation } from "react-router-dom";



export default function ContractSection() {
    const { contract } = useContracts();
    const { profile } = useProfileData();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const location = useLocation()


    const userType = location.pathname.includes("house_manager") ? "house_manager" : "employer";

    const handleOpenModal = () => setIsModalOpen(true)
    const handleCloseModal = () => setIsModalOpen(false)

    return (
        <div className={styles.contractStatus}>
            {contract && contract.length > 0 ? (
            <div>
                <h3>Contract Status</h3>
                {contract.map((c) => (
                <div key={c.id} className={styles.contract}>
                    {c.status === 'Pending' || c.status === 'Declined' ? (
                        <p>{profile.first_name} has {c.status} Contract for {c.employer_name} </p>
                    ) : (
                        <div>
                        <p>{profile.first_name} has a contract with {c.employer_name} that expires on {c.end_date}</p>
                        <p>Status: <strong>Active</strong></p>
                        </div>
                    )}
                </div>
                ))}
            </div>
            ) : (
            <div>
                <p>No contract available</p>
                {userType !== 'employer' && (
                <button onClick={handleOpenModal} className={styles.createContractbutton}>
                    Create Contract
                    </button>
                )}
            </div>
            )}
        </div>
    )
}